<template>
  <b-container class="mt-5">
    <b-row>
      <b-col sm="12" md="12" offset-md="0">
        <iframe
          id="iframe-stats"
          :src="get_selected_element().link"
          :height="get_selected_element().height"
          width="100%"
          frameBorder="0"
          scrolling="no"
        ></iframe>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5>Previous versions:</h5>
      </b-col>
    </b-row>
    <b-row style="height:50px" v-for="item in get_history_list()" :key="item['date']">
      <b-col class="mb-3" sm="6">
        <span>{{ item.name }}</span>
      </b-col>
      <b-col class="mb-3" sm="6">
        <b-button @click="selected = item.id" v-if="item.id != selected" size="sm" class="btn-statistics">View</b-button>
        <span v-else>Viewing</span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import mapping from "../../public/mapping.json";

export default {
  data() {
    return {
      selected:0
    };
  },
  methods: {
    get_selected_element(){
      let selected_id = this.selected
      let data = this.get_history_list()
      let element = undefined
      data.forEach(e => {
        if(e.id == selected_id){
          element = e
        }
      })
      if(element === undefined){
        throw 'Selected html file not found.'
      }
      return element
    },
    get_history_list() {
      let options = { year: "numeric", month: "long", day: "numeric" };
      let data = [];
      mapping["history"].forEach((e, i) => {
        let link = e["link"];
        let date_str = link.split("_")[0];
        let date = Date.parse(date_str);
        let name = new Date(date_str).toLocaleDateString(undefined, options);
        data.push({
          id: i,
          date: date,
          name: name,
          link: link,
          height: e["height"],
        });
      });
      data.sort((a, b) => b.date - a.date);
      // this.selected = data[0]["id"]
      return data;
    }
  },
  mounted() {
    let data = this.get_history_list()
    let latest = data[0]["id"]
    this.selected = latest
  }
};
</script>

<style>
#iframe-stats {
  overflow: hidden !important;
}

.btn-statistics{
  color:#090d54;
  background-color:white;
  border:1px solid #090d54;
}
</style>